"use client"
import React, { useRef } from "react";
import Slider from "react-slick";

function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "none", background: "red" }}
        onClick={onClick}
      />
    );
  }
  
  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "none", background: "green" }}
        onClick={onClick}
      />
    );
  }
function AutoPlayMethods({children,className}) {
  let sliderRef = useRef(null);
  const play = () => {
    sliderRef.slickPlay();
  };
  const pause = () => {
    sliderRef.slickPause();
  };

  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 700,
    speed: 1000,
    pauseOnHover: false,
    // adaptiveHeight: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />
  };

  return (
    <div className={`slider-container relative package-slider ${className}`}  onMouseOver={play} onMouseOut={pause}>
      <Slider ref={slider => (sliderRef = slider)} {...settings}>
        {children}
      </Slider>
        {/* <button className="button absolute top-0 left-0 right-0 bottom-0"   >
          
        </button> */}
      
    </div>
  );
}
export default AutoPlayMethods;